import { ILangEntity, TLang } from "./interface";
import { LANG_KEY, langStorageEntity } from "./storage";
import store from '@/store';
import { LANG_MODULE_NAME } from "@/store/modules/lang";
import i18n from '@/plugins/i18n/i18n.ts';

export const langEntity: ILangEntity = {

	get lang(): TLang {
		return langStorageEntity[LANG_KEY] as TLang;
	},

	set lang(v: TLang) {
		langStorageEntity[LANG_KEY] = v;
	},

	get langState(): TLang {
		return store.getters[`${LANG_MODULE_NAME}/lang`];
	},

	set langState(v: TLang) {
		store.commit(`${LANG_MODULE_NAME}/setLang`, v);
	},

	get langLocale(): TLang {
		return i18n.locale as TLang;
	},

	set langLocale(v: TLang) {
		i18n.locale = v;
	}

};